function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import _ from 'lodash';
import { Link, safePrefix } from '../utils';

var Header =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Header, _React$Component);

  function Header() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Header.prototype;

  _proto.render = function render() {
    var _this = this;

    return React.createElement("header", {
      id: "masthead",
      className: "site-header"
    }, React.createElement("div", {
      className: "inner"
    }, React.createElement("div", {
      className: "site-header-inside"
    }, React.createElement("div", {
      className: "site-branding"
    }, _.get(this.props, 'pageContext.site.siteMetadata.header.logo_img') && React.createElement("p", {
      className: "site-logo"
    }, React.createElement(Link, {
      to: safePrefix('/')
    }, React.createElement("img", {
      src: safePrefix(_.get(this.props, 'pageContext.site.siteMetadata.header.logo_img')),
      alt: "Logo"
    }))), _.get(this.props, 'pageContext.frontmatter.template') === 'home' ? React.createElement("h1", {
      className: "site-title"
    }, React.createElement(Link, {
      to: safePrefix('/')
    }, _.get(this.props, 'pageContext.site.siteMetadata.header.title'))) : React.createElement("p", {
      className: "site-title"
    }, React.createElement(Link, {
      to: safePrefix('/')
    }, _.get(this.props, 'pageContext.site.siteMetadata.header.title')))), _.get(this.props, 'pageContext.menus.main') && _.get(this.props, 'pageContext.site.siteMetadata.header.has_nav') && React.createElement(React.Fragment, null, React.createElement("nav", {
      id: "main-navigation",
      className: "site-navigation",
      "aria-label": "Main Navigation"
    }, React.createElement("div", {
      className: "site-nav-inside"
    }, React.createElement("button", {
      id: "menu-close",
      className: "menu-toggle"
    }, React.createElement("span", {
      className: "screen-reader-text"
    }, "Menu"), React.createElement("span", {
      className: "icon-close",
      "aria-hidden": "true"
    })), React.createElement("ul", {
      className: "menu"
    }, _.map(_.get(this.props, 'pageContext.menus.main'), function (item, item_idx) {
      return React.createElement("li", {
        key: item_idx,
        className: 'menu-item ' + (_.get(_this.props, 'pageContext.url') === _.get(item, 'url') ? ' current-menu-item' : '')
      }, React.createElement(Link, {
        to: safePrefix(_.get(item, 'url'))
      }, _.get(item, 'title')));
    })))), React.createElement("button", {
      id: "menu-open",
      className: "menu-toggle"
    }, React.createElement("span", {
      className: "screen-reader-text"
    }, "Menu"), React.createElement("span", {
      className: "icon-menu",
      "aria-hidden": "true"
    }))))));
  };

  return Header;
}(React.Component);

export { Header as default };